import type { AppNotification } from '@src/providers/AppNotifications';
import type { ToastPropsBase, ValueOf } from '@talos/kyoko';
import type React from 'react';

export interface AppInboxToastStateItem extends ToastPropsBase {
  /** Toast type to display */
  appInboxToastType: AppNotification['Type'];
  /** Notification Id for the toast */
  id: string;
  /** Bolded title for the toast
   * - specific display implementations may override it, but useful regardless for debugging */
  title: React.ReactNode;
  /** Subtext for toast
   * - specific display implementations may override it, but useful regardless for debugging */
  description?: React.ReactNode;
  /** ISO Date when the toast came in */
  timeStamp: string;
  /** Style level of toast */
  variant: AppNotificationSeverity;
  /** URL to navigate to when the toast is clicked */
  targetUrl?: string;
  /** Optional callback to resolve URL with runtime layout context */
  targetUrlResolver?: (layoutId?: string) => string | undefined;
}

export const AppNotificationSeverity = {
  /** System-driven (Inbox-managed) Notifications */
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const;
export type AppNotificationSeverity = ValueOf<typeof AppNotificationSeverity>;
